import { render, staticRenderFns } from "./UserIdentity.vue?vue&type=template&id=154c655a&"
import script from "./UserIdentity.vue?vue&type=script&lang=js&"
export * from "./UserIdentity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports